import { useState, useRef } from 'react';
import { Collapse } from 'reactstrap';
import { useAppContext } from '@front-activerse/common-components';

const DayPlanAdvice = ({ advice }) => {
  const {
    svgInline: { DownArrow },
    images: { playBtn },
  } = useAppContext();

  const [collapse, setCollapse] = useState(false);
  const [visiblePosters, setVisiblePosters] = useState(
    (advice.media || []).reduce((acc, _, index) => {
      acc[index] = true;
      return acc;
    }, {})
  );
  const videoRefs = useRef((advice.media || []).map(() => null));

  const description = advice.description
    .trim()
    .split('\n')
    .reduce((carry, line) => {
      if (carry.length) {
        carry.push(<br key={line} />);
      }
      carry.push(line);
      return carry;
    }, []);

  const playVideo = async (index) => {
    setVisiblePosters((prev) => ({ ...prev, [index]: false }));

    try {
      await videoRefs.current[index].play();
    } catch (err) {
      console.warn(err);
    }
  };

  const handleVideoEnded = (index) => {
    setVisiblePosters((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="advice">
      <h3 onClick={() => setCollapse(!collapse)}>
        {advice.title}
        <span className={collapse ? 'collapse-arrow open' : 'collapse-arrow'}>
          <span className="SVGInline">
            <DownArrow />
          </span>
        </span>
      </h3>

      <Collapse isOpen={collapse}>
        <p>{description}</p>

        {(advice.media || []).map((media, index) => (
          <div
            key={index}
            className="embed-responsive ratio ratio-1x1 mt-s overflow-hidden rounded-2"
          >
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              src={media.videoUrl}
              controls
              playsInline
              controlsList="nodownload"
              disablePictureInPicture
              onEnded={() => handleVideoEnded(index)}
              poster={media.posterUrl}
            />
            {visiblePosters[index] && (
              <div
                style={{
                  backgroundImage: `url(${media.posterUrl
                    .replace('(', '%28')
                    .replace(')', '%29')})`,
                }}
                className="embed-responsive-item d-flex align-items-center justify-content-center"
                onClick={() => playVideo(index)}
              >
                <img src={playBtn} alt="" />
              </div>
            )}
          </div>
        ))}
      </Collapse>
    </div>
  );
};

export default DayPlanAdvice;
